import {Field} from "formik";
import React from "react";
import Translate from "../../../../components/Translate";

export default function CampoInputLista({
                                            elemento,
                                            valore,
                                            disabled,
                                            fieldRef,
                                            onValidate,
                                            onFocusCampo,
                                            onChangeCampo,
                                            onBlurCampo,
                                        }) {

    return (
        <Field
            as={"select"}
            id={elemento.id_kpi_elemento}
            name={elemento.cella}
            className={"form-select"}
            value={valore}
            placeholder={elemento.placeholder}
            disabled={disabled}
            innerRef={fieldRef}
            onFocus={onFocusCampo}
            onChange={onChangeCampo}
            onBlur={onBlurCampo}
            validate={onValidate}
            style={{fontSize: 'inherit'}}
        >
            {
                elemento.valori_lista && elemento.valori_lista.split(',').map((val, idx) => {
                    const cleanVal = val.trim();
                    return (
                        <option 
                            value={cleanVal === '---' ? '' : cleanVal} 
                            key={idx}
                        >
                            <Translate>{cleanVal}</Translate>
                        </option>
                    );
                })
            }
        </Field>
    );
}